import { render, staticRenderFns } from "./UserViewUserInfo.vue?vue&type=template&id=b1d2be7e&"
import script from "./UserViewUserInfo.vue?vue&type=script&lang=js&"
export * from "./UserViewUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports